module.exports = __webpack_public_path__ + "static/img/datashare4.78a2fab9.png";